import { blackScholesModelCalculationService } from "../BlackScholesModelCalculationService";
import dayjs from "dayjs";
import { BasePortfolioPositionsCalculationService } from "./abstracts/BasePortfolioPositionsCalculationService";
import { PortfolioGroupedItem } from "../../../screens/positions-and-orders/models/PortfolioGroupedItem";

export class PortfolioPositionsVegaCalculationService extends BasePortfolioPositionsCalculationService {
    protected calculateForFutures(_: PortfolioGroupedItem): number {
        return 0;
    }

    protected calculateForOption(position: PortfolioGroupedItem,
        underlyingPrice: number, timeToExpirationInShareOfYear: number,
        getImpliedVolatility: (position: PortfolioGroupedItem) => number,
    ): number {
        const isExpired = position.expireAt !== null
            ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(position.expireAt, dayjs().toDate()) < 0
            : true;

        if (isExpired) {
            // todo: calc option price after expiration
            return 0;
        }
        
        if (position.impliedVolatility === null) {
            throw new Error("ImpliedVolatility cannot be null!");
        }

        if (position.strike === null) {
            throw new Error("Order property 'strike' is null.")
        }
        
        return blackScholesModelCalculationService.getVega(
            underlyingPrice, position.strike, timeToExpirationInShareOfYear, getImpliedVolatility(position));
    }

    protected getMinTimeToExpirationInShareOfYear(): number {
        return 1 / 365;
    }
}